function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.333 0.333008H48.333C51.2663 0.333008 53.6663 2.73301 53.6663 5.66634V37.6663C53.6663 40.5997 51.2663 42.9997 48.333 42.9997H16.333C13.3997 42.9997 10.9997 40.5997 10.9997 37.6663V5.66634C10.9997 2.73301 13.3997 0.333008 16.333 0.333008ZM0.333008 10.9997H5.66634V48.333H42.9997V53.6663H5.66634C2.73301 53.6663 0.333008 51.2663 0.333008 48.333V10.9997ZM48.333 37.6663H16.333V5.66634H48.333V37.6663ZM42.9997 18.9997H21.6663V24.333H42.9997V18.9997ZM21.6663 26.9997H32.333V32.333H21.6663V26.9997ZM42.9997 10.9997H21.6663V16.333H42.9997V10.9997Z",
  fill: "#F2F2F2"
});

var SvgLibraryBooks24 = function SvgLibraryBooks24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLibraryBooks24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/library_books_24.c038e44a.svg";
export { ForwardRef as ReactComponent };